(function() {
  var __indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  vtex.define('shipping/script/ShippingData',['flight/lib/component', 'shipping/script/setup/extensions', 'shipping/script/models/Address', 'shipping/script/component/AddressSearch', 'shipping/script/component/AddressForm', 'shipping/script/component/AddressList', 'shipping/script/component/ShippingOptions', 'shipping/script/component/ShippingSummary', 'shipping/script/component/CountrySelect', 'shipping/script/component/ShippingDataStore', 'shipping/script/mixin/withi18n', 'shipping/script/mixin/withValidation', 'shipping/script/mixin/withShippingStateMachine', 'shipping/script/mixin/withImplementedCountries', 'shipping/templates/shippingData', 'shipping/script/libs/selectize/selectize', 'link!shipping/script/libs/selectize/selectize.bootstrap2.css', 'link!shipping/style/style.css'], function(defineComponent, extensions, Address, AddressSearch, AddressForm, AddressList, ShippingOptions, ShippingSummary, CountrySelect, ShippingDataStore, withi18n, withValidation, withShippingStateMachine, withImplementedCountries, template, selectize) {
    var ShippingData;
    ShippingData = function() {
      var _this = this;
      this.defaultAttrs({
        API: null,
        orderForm: false,
        componentsState: {},
        data: {
          valid: false,
          active: false,
          visited: false,
          loading: false,
          deliveryCountries: false,
          countryRules: {},
          country: false,
          logisticsConfiguration: null
        },
        stateMachine: false,
        goToPaymentButtonSelector: '.btn-go-to-payment',
        goToPaymentButtonWrapperSelector: '.btn-go-to-payment-wrapper',
        editShippingDataSelector: '#edit-shipping-data',
        shippingTitleSelector: '.accordion-shipping-title',
        addressNotFilledSelector: '.address-not-filled-verification',
        shippingStepSelector: '.step',
        shippingStepTitleSelector: '.accordion-shipping-title',
        shippingSummarySelector: '.shipping-summary-placeholder',
        addressFormSelector: '.address-form-placeholder',
        addressSearchSelector: '.address-search-placeholder',
        addressListSelector: '.address-list-placeholder',
        shippingOptionsSelector: '.address-shipping-options',
        countrySelectSelector: '.country-select-placeholder'
      });
      this.orderFormUpdated = function(ev, orderForm) {
        var country, shippingData, _ref, _ref1, _ref2, _ref3, _ref4;
        this.attr.orderForm = _.clone(orderForm);
        this.setLocale((_ref = orderForm.clientPreferencesData) != null ? _ref.locale : void 0);
        shippingData = this.attr.orderForm.shippingData;
        if (shippingData == null) {
          if (this.attr.orderForm.items.length === 0) {
            this.validate();
          }
          return;
        }
        this.attr.data.deliveryCountries = this.getDeliveryCountries(this.attr.orderForm);
        this.attr.data.hasAvailableAddresses = shippingData.availableAddresses.length > 1;
        this.attr.data.hasDeliveries = ((shippingData != null ? shippingData.logisticsInfo : void 0) != null) && _.all(shippingData.logisticsInfo, function(li) {
          return li.slas.length > 0;
        });
        if (this.attr.data.canEditData == null) {
          this.attr.data.canEditData = this.attr.orderForm.canEditData;
        }
        if (this.attr.orderForm.canEditData !== this.attr.data.canEditData) {
          this.attr.data.userIsNowLoggedIn = true;
          this.attr.data.canEditData = this.attr.orderForm.canEditData;
        } else {
          this.attr.data.userWantsToCreateNewAddress = false;
        }
        country = (_ref1 = (_ref2 = (_ref3 = shippingData.address) != null ? _ref3.country : void 0) != null ? _ref2 : (_ref4 = this.attr.orderForm.storePreferencesData) != null ? _ref4.countryCode : void 0) != null ? _ref1 : this.attr.data.deliveryCountries[0];
        return this.countrySelected(null, country);
      };
      this.resolveState = function(changedContry) {
        var _ref;
        if (((_ref = this.attr.stateMachine.current) === 'none' || _ref === 'empty' || _ref === 'summary') || this.attr.data.userIsNowLoggedIn || changedContry) {
          if (this.attr.data.userIsNowLoggedIn) {
            this.attr.data.userIsNowLoggedIn = false;
            if (this.attr.orderForm.canEditData && !this.isValid()) {
              this.trigger('componentValidated.vtex', [false]);
              this.trigger('componentDone.vtex');
            }
          }
          if (this.attr.data.active) {
            if (this.attr.data.hasAvailableAddresses && !changedContry) {
              this.attr.stateMachine.showList(this.attr.orderForm);
              this.attr.stateMachine.next();
            } else if (this.attr.data.userWantsToCreateNewAddress) {
              this.attr.data.userWantsToCreateNewAddress = false;
              this.newAddress();
            } else {
              this.attr.stateMachine.showForm(this.attr.orderForm);
              this.attr.stateMachine.next();
            }
          } else {
            this.attr.stateMachine.showSummary(this.attr.orderForm);
            this.attr.stateMachine.next();
          }
        }
        return this.validate();
      };
      this.enable = function() {
        var address, country, deliveryCountries, e, invalidAddress, orderForm, rules, shippingData, shouldHaveOneAddress, _ref, _ref1;
        try {
          orderForm = this.attr.orderForm;
          deliveryCountries = this.attr.data.deliveryCountries;
          shippingData = orderForm.shippingData;
          country = (_ref = deliveryCountries[0]) != null ? _ref : shippingData != null ? (_ref1 = shippingData.address) != null ? _ref1.country : void 0 : void 0;
          rules = this.attr.data.countryRules[country];
          address = new Address(shippingData.address);
          shouldHaveOneAddress = orderForm.canEditData === true && orderForm.loggedIn === false && (orderForm.giftRegistryData == null);
          invalidAddress = orderForm.canEditData === true && (!(shippingData != null ? shippingData.address : void 0) || address.validate(rules) !== true);
          if (invalidAddress || shouldHaveOneAddress) {
            this.attr.stateMachine.showForm(orderForm);
            return this.attr.stateMachine.next();
          } else if (this.attr.stateMachine.can('showList')) {
            this.attr.stateMachine.showList(orderForm);
            return this.attr.stateMachine.next();
          }
        } catch (_error) {
          e = _error;
          return console.log(e);
        }
      };
      this.disable = function() {
        var xhr,
          _this = this;
        if (this.attr.stateMachine.can('showSummary') && this.attr.stateMachine.current !== 'summary') {
          this.attr.stateMachine.showSummary(this.attr.orderForm);
          this.attr.stateMachine.next();
          if (this.isValid()) {
            xhr = ShippingDataStore.sendAttachment(this.attr.orderForm.shippingData);
            return xhr != null ? xhr.fail(function(reason) {
              _this.trigger('componentValidated.vtex', [[reason]]);
              return _this.done();
            }) : void 0;
          }
        }
      };
      this.profileUpdated = function(e, profile) {
        return this.attr.profileFromEvent = profile;
      };
      this.tryDone = function(ev) {
        var address, addressFormVal, shippingOptionsVal, _ref, _ref1,
          _this = this;
        if (ev != null) {
          ev.stopPropagation();
        }
        if (this.attr.stateMachine.current === 'addressFormSLA') {
          _ref = [$.Deferred(), $.Deferred()], addressFormVal = _ref[0], shippingOptionsVal = _ref[1];
          this.select('addressFormSelector').one('componentValidated.vtex', function(e, errors) {
            if (errors.length === 0) {
              return addressFormVal.resolve();
            }
          });
          this.select('shippingOptionsSelector').one('componentValidated.vtex', function(e, errors) {
            if (errors.length === 0) {
              return shippingOptionsVal.resolve();
            }
          });
          $.when(addressFormVal, shippingOptionsVal).then(function() {
            return _this.done();
          });
          this.select('addressFormSelector').trigger('validate.vtex');
          this.select('shippingOptionsSelector').trigger('validate.vtex');
          return;
        }
        if (this.attr.stateMachine.current === 'listSLA') {
          address = new Address(this.attr.orderForm.shippingData.address);
          if (address.validate(this.attr.data.countryRules[address.country]) !== true) {
            this.attr.stateMachine.showForm(this.attr.orderForm);
            this.attr.stateMachine.next();
            return;
          }
        }
        if ((_ref1 = this.attr.stateMachine.current) === 'listSLA' || _ref1 === 'anonListSLA') {
          this.select('shippingOptionsSelector').one('componentValidated.vtex', function(e, errors) {
            if (errors.length === 0) {
              return _this.done();
            }
          });
          this.select('shippingOptionsSelector').trigger('validate.vtex');
          return;
        }
        return this.done();
      };
      this.done = function() {
        var valid;
        valid = this.validate();
        if (valid.length > 0) {
          this.attr.stateMachine.showForm(this.attr.orderForm);
        }
        return this.trigger('componentDone.vtex');
      };
      this.addressDefaults = function(address) {
        var firstName, lastName, _ref, _ref1, _ref2, _ref3;
        firstName = ((_ref = this.attr.orderForm.clientProfileData) != null ? _ref.firstName : void 0) || ((_ref1 = this.attr.profileFromEvent) != null ? _ref1.firstName : void 0);
        lastName = ((_ref2 = this.attr.orderForm.clientProfileData) != null ? _ref2.lastName : void 0) || ((_ref3 = this.attr.profileFromEvent) != null ? _ref3.lastName : void 0);
        if (firstName && (address.receiverName === '' || !address.receiverName)) {
          address.receiverName = firstName + ' ' + lastName;
        }
        address.country || (address.country = this.attr.data.country);
        return address;
      };
      this.addressSearchLoad = function(ev) {
        if (ev != null) {
          ev.stopPropagation();
        }
        return this.attr.stateMachine.searchAddress();
      };
      this.addressSearchResult = function(ev, address) {
        var _ref;
        this.attr.orderForm.shippingData.address = this.addressDefaults(address);
        this.attr.orderForm.shippingData.address.country = (_ref = address != null ? address.country : void 0) != null ? _ref : this.attr.data.country;
        this.attr.orderForm.shippingData.address.postalCodeIsValid = address.postalCode != null;
        return this.addressKeysUpdated(null, this.attr.orderForm.shippingData.address);
      };
      this.addressSelected = function(ev, address) {
        var _ref,
          _this = this;
        if (ev != null) {
          ev.stopPropagation();
        }
        address.isValid = true;
        this.addressUpdated(ev, address);
        if (this.attr.requestAddressSelected) {
          this.attr.requestAddressSelected.abort();
        }
        this.attr.stateMachine.requestSLA();
        this.attr.requestAddressSelected = ShippingDataStore.sendAttachment(this.attr.orderForm.shippingData);
        return (_ref = this.attr.requestAddressSelected) != null ? _ref.done(function(orderForm) {
          var hasDeliveries;
          hasDeliveries = _this.attr.data.hasDeliveries;
          if (_this.attr.stateMachine.can('loadSLA') || _this.attr.stateMachine.can('loadNoSLA')) {
            if (hasDeliveries) {
              return _this.attr.stateMachine.loadSLA(orderForm);
            } else {
              return _this.attr.stateMachine.loadNoSLA(orderForm);
            }
          }
        }) : void 0;
      };
      this.addressUpdated = function(ev, address) {
        ev.stopPropagation();
        this.attr.orderForm.shippingData.address = address;
        this.validate();
        if (address.isValid) {
          return this.select('shippingSummarySelector').trigger('addressSelected.vtex', [address]);
        }
      };
      this.addressFormValidated = function(ev, results) {
        if (ev != null) {
          ev.stopPropagation();
        }
        return this.validate();
      };
      this.addressKeysUpdated = function(ev, address) {
        var clearAddress, country, hasDeliveries, knownAddress, _ref, _ref1, _ref2,
          _this = this;
        if (!address.postalCodeIsValid) {
          address = _.extend({}, address, {
            postalCode: null
          });
        }
        knownAddress = _.find((_ref = this.attr.orderForm.shippingData) != null ? _ref.availableAddresses : void 0, function(a) {
          var _ref1, _ref2, _ref3, _ref4, _ref5, _ref6;
          return a.addressId === address.addressId && a.country === address.country && ((_ref1 = a.postalCode) != null ? _ref1.replace('-', '') : void 0) === ((_ref2 = address.postalCode) != null ? _ref2.replace('-', '') : void 0) && ((_ref3 = a.geoCoordinates) != null ? _ref3[0] : void 0) === ((_ref4 = address.geoCoordinates) != null ? _ref4[0] : void 0) && ((_ref5 = a.geoCoordinates) != null ? _ref5[1] : void 0) === ((_ref6 = address.geoCoordinates) != null ? _ref6[1] : void 0);
        });
        if (knownAddress) {
          this.attr.orderForm.shippingData.address = address;
          this.attr.stateMachine.requestSLA();
          hasDeliveries = this.attr.data.hasDeliveries;
          if (this.attr.stateMachine.can('loadSLA') || this.attr.stateMachine.can('loadNoSLA')) {
            if (hasDeliveries) {
              this.attr.stateMachine.loadSLA(this.attr.orderForm);
            } else {
              this.attr.stateMachine.loadNoSLA(this.attr.orderForm);
            }
          }
          return;
        }
        if (address.postalCodeIsValid || address.geoCoordinatesIsValid) {
          this.attr.stateMachine.requestSLA();
          country = (_ref1 = address.country) != null ? _ref1 : this.attr.data.country;
          clearAddress = false;
          if (this.attr.data.countryRules[country].postalCodeByInput && !address.geoCoordinatesIsValid) {
            clearAddress = true;
          }
          if (this.attr.requestAddressKeys) {
            this.attr.requestAddressKeys.abort();
          }
          this.attr.requestAddressKeys = ShippingDataStore.sendAttachment({
            address: address,
            clearAddressIfPostalCodeNotFound: clearAddress
          });
          return (_ref2 = this.attr.requestAddressKeys) != null ? _ref2.done(function(orderForm) {
            hasDeliveries = _this.attr.data.hasDeliveries;
            if (_this.attr.stateMachine.can('loadSLA') || _this.attr.stateMachine.can('loadNoSLA')) {
              if (hasDeliveries) {
                return _this.attr.stateMachine.loadSLA(orderForm);
              } else {
                return _this.attr.stateMachine.loadNoSLA(orderForm);
              }
            }
          }).fail(function(reason) {
            if (reason.statusText === 'abort') {
              return;
            }
            console.log(reason);
            _this.attr.orderForm.apiCallError = reason;
            _this.attr.stateMachine.showForm(_this.attr.orderForm);
            _this.attr.stateMachine.next();
            return $(window).trigger('addMessage.vtex', {
              type: 'fatal',
              content: {
                detail: i18n.t('shipping.errors.shippingOptions'),
                html: false
              },
              close: i18n.t('global.close')
            });
          }) : void 0;
        } else if (address.ignoreGeoCoords) {
          this.attr.orderForm.shippingData.address = address;
          this.attr.stateMachine.showForm(this.attr.orderForm);
          return this.attr.stateMachine.next();
        }
      };
      this.addressKeysInvalidated = function(ev, address) {
        var deliveryCountries, hasAvailableAddresses, logisticsConfiguration, rules;
        rules = this.attr.data.countryRules[address.country];
        hasAvailableAddresses = this.attr.data.hasAvailableAddresses;
        deliveryCountries = this.attr.data.deliveryCountries;
        logisticsConfiguration = this.attr.data.logisticsConfiguration;
        return this.attr.stateMachine.showSearch(rules, address, hasAvailableAddresses, deliveryCountries, logisticsConfiguration);
      };
      this.editAddress = function(ev, address) {
        var vtexIdOptions, _ref, _ref1, _ref2, _ref3;
        if (ev != null) {
          ev.stopPropagation();
        }
        if (!this.attr.orderForm.canEditData) {
          vtexIdOptions = {
            returnUrl: window.location.href,
            userEmail: typeof vtexjs !== "undefined" && vtexjs !== null ? (_ref = vtexjs.checkout) != null ? (_ref1 = _ref.orderForm) != null ? (_ref2 = _ref1.clientProfileData) != null ? _ref2.email : void 0 : void 0 : void 0 : void 0,
            locale: this.attr.locale
          };
          return (_ref3 = window.vtexid) != null ? _ref3.start(vtexIdOptions) : void 0;
        }
        this.attr.stateMachine.showForm(this.attr.orderForm);
        return this.attr.stateMachine.next();
      };
      this.newAddress = function(ev) {
        var vtexIdOptions, _ref, _ref1, _ref2, _ref3, _ref4;
        if (ev != null) {
          ev.stopPropagation();
        }
        if (!this.attr.orderForm.canEditData) {
          this.attr.data.userWantsToCreateNewAddress = true;
          vtexIdOptions = {
            returnUrl: window.location.href,
            userEmail: typeof vtexjs !== "undefined" && vtexjs !== null ? (_ref = vtexjs.checkout) != null ? (_ref1 = _ref.orderForm) != null ? (_ref2 = _ref1.clientProfileData) != null ? _ref2.email : void 0 : void 0 : void 0 : void 0,
            locale: this.attr.locale
          };
          return (_ref3 = window.vtexid) != null ? _ref3.start(vtexIdOptions) : void 0;
        }
        if ((_ref4 = this.attr.orderForm.shippingData) != null) {
          _ref4.address = {};
        }
        this.attr.stateMachine.showForm(this.attr.orderForm);
        return this.attr.stateMachine.next();
      };
      this.cancelAddressEdit = function(ev) {
        var defaultAddress, listLength;
        if (ev != null) {
          ev.stopPropagation();
        }
        this.attr.stateMachine.showList(this.attr.orderForm);
        this.attr.stateMachine.next();
        listLength = this.attr.orderForm.shippingData.availableAddresses.length;
        if (listLength > 0) {
          defaultAddress = this.attr.orderForm.shippingData.availableAddresses[listLength - 1];
          return this.select('addressListSelector').trigger('selectAddress.vtex', defaultAddress.addressId);
        }
      };
      this.deliverySelected = function(ev, logisticsInfo) {
        this.attr.orderForm.shippingData.logisticsInfo = logisticsInfo;
        return this.validate();
      };
      this.loadExistingCountry = function(country, changedContry) {
        var deps,
          _this = this;
        deps = ['shipping/script/rule/Country' + country, 'shipping/templates/countries/addressForm' + country, 'shipping/templates/addressSearch', 'shipping/templates/shippingOptions', 'shipping/templates/deliveryWindows'];
        return vtex.curl(deps, function(CountryRule) {
          var acceptsGeoCoords, countryRules, _ref;
          countryRules = _this.attr.data.countryRules;
          countryRules[country] = new CountryRule();
          _this.attr.data.states = countryRules[country].states;
          _this.attr.data.regexes = countryRules[country].regexes;
          acceptsGeoCoords = (__indexOf.call((_ref = _this.attr.data.logisticsConfiguration) != null ? _ref.acceptSearchKeys : void 0, 'geoCoords') >= 0);
          if (acceptsGeoCoords) {
            _this.loadGoogleMapsAPI();
          }
          return _this.resolveState(changedContry);
        });
      };
      this.loadUniversal = function(country, changedContry) {
        var deps,
          _this = this;
        deps = ['shipping/script/rule/CountryUNI', 'shipping/templates/countries/addressFormUNI', 'shipping/templates/addressSearch', 'shipping/templates/shippingOptions', 'shipping/templates/deliveryWindows'];
        return vtex.curl(deps, function(CountryRule) {
          var acceptsGeoCoords, countryRules, _ref;
          countryRules = _this.attr.data.countryRules;
          countryRules[country] = new CountryRule();
          _this.attr.data.states = countryRules[country].states;
          _this.attr.data.regexes = countryRules[country].regexes;
          acceptsGeoCoords = (__indexOf.call((_ref = _this.attr.data.logisticsConfiguration) != null ? _ref.acceptSearchKeys : void 0, 'geoCoords') >= 0);
          if (acceptsGeoCoords) {
            _this.loadGoogleMapsAPI();
          }
          return _this.resolveState(changedContry);
        });
      };
      this.countrySelected = function(ev, country, changedContry) {
        var _ref, _ref1, _ref2;
        this.attr.data.country = country;
        if (changedContry) {
          if ((_ref = this.attr.orderForm) != null) {
            if ((_ref1 = _ref.shippingData) != null) {
              if ((_ref2 = _ref1.address) != null) {
                _ref2.country = country;
              }
            }
          }
        }
        if (this.isCountryImplemented(country)) {
          return this.loadExistingCountry(country, changedContry);
        } else {
          return this.loadUniversal(country, changedContry);
        }
      };
      this.loadGoogleMapsAPI = function() {
        var googleAPIKey, script;
        if (!window.vtex.maps.isGoogleMapsAPILoaded && !window.vtex.maps.isGoogleMapsAPILoading) {
          window.vtex.maps.isGoogleMapsAPILoading = true;
          googleAPIKey = window.vtex.googleMapsApiKey;
          script = document.createElement("script");
          script.type = "text/javascript";
          script.src = "//maps.googleapis.com/maps/api/js?libraries=places&key=" + googleAPIKey + "&language=" + this.attr.locale + "&callback=window.vtex.maps.googleMapsAPILoaded";
          document.body.appendChild(script);
        }
      };
      this.transformCountries = function(countries) {
        var country, newCountries, _i, _len,
          _this = this;
        newCountries = [];
        for (_i = 0, _len = countries.length; _i < _len; _i++) {
          country = countries[_i];
          newCountries.push({
            code: country,
            name: i18n.t('countries.' + country)
          });
        }
        newCountries = newCountries.sort(function(a, b) {
          return a.name.localeCompare(b.name);
        });
        return _.map(newCountries, function(country) {
          return country.code;
        });
      };
      this.getDeliveryCountries = function(orderForm) {
        var deliveryCountries, _ref;
        deliveryCountries = _.uniq(_.reduceRight(orderForm.shippingData.logisticsInfo, (function(memo, l) {
          return memo.concat(l.shipsTo);
        }), []));
        deliveryCountries = this.transformCountries(deliveryCountries);
        if (deliveryCountries.length === 0) {
          deliveryCountries = [(_ref = orderForm.storePreferencesData) != null ? _ref.countryCode : void 0];
        }
        return deliveryCountries;
      };
      this.validateAddress = function() {
        var currentAddress;
        if (this.attr.orderForm.canEditData) {
          try {
            currentAddress = new Address(this.attr.orderForm.shippingData.address);
            return currentAddress.validate(this.attr.data.countryRules[currentAddress.country]);
          } catch (_error) {}
          return "Unable to validate address";
        } else {
          return true;
        }
      };
      this.allScheduledHasWindows = function(logisticsInfo) {
        var allScheduledHasWindows;
        allScheduledHasWindows = _.all(logisticsInfo, function(li) {
          var selectedSla, selectedSlaName;
          selectedSlaName = li.selectedSla;
          selectedSla = _.find(li.slas, function(sla) {
            return sla.id === selectedSlaName;
          });
          if (!selectedSla) {
            return true;
          }
          if (selectedSla.availableDeliveryWindows.length > 0) {
            return selectedSla.deliveryWindow != null;
          }
          return true;
        });
        return allScheduledHasWindows;
      };
      this.validateShippingOptions = function() {
        var logisticsInfo, _ref;
        logisticsInfo = (_ref = this.attr.orderForm.shippingData) != null ? _ref.logisticsInfo : void 0;
        if ((logisticsInfo != null ? logisticsInfo.length : void 0) === 0) {
          return "Logistics info must exist";
        }
        if (_.find(logisticsInfo, function(li) {
          return li.selectedSla === void 0;
        })) {
          return "No selected SLA";
        }
        if (!this.allScheduledHasWindows(logisticsInfo)) {
          return "No delivery window";
        }
        return true;
      };
      this.localeSelected = function(ev, locale) {
        _this.setLocale(locale);
        return _this.requireLocale().then(function() {
          return _this.$node.i18n();
        });
      };
      return this.after('initialize', function() {
        var locale, _ref, _ref1, _ref2, _ref3, _ref4, _ref5,
          _this = this;
        this.attr.data.logisticsConfiguration = {
          acceptSearchKeys: ["postalCode"]
        };
        if (window.vtex.googleMapsApiKey) {
          this.attr.data.logisticsConfiguration.acceptSearchKeys.push("geoCoords");
        }
        this.attr.stateMachine = this.createStateMachine();
        this.setLocalePath('shipping/script/translation/');
        if (typeof vtexjs !== "undefined" && vtexjs !== null ? (_ref = vtexjs.checkout) != null ? (_ref1 = _ref.orderForm) != null ? (_ref2 = _ref1.clientPreferencesData) != null ? _ref2.locale : void 0 : void 0 : void 0 : void 0) {
          locale = typeof vtexjs !== "undefined" && vtexjs !== null ? (_ref3 = vtexjs.checkout) != null ? (_ref4 = _ref3.orderForm) != null ? (_ref5 = _ref4.clientPreferencesData) != null ? _ref5.locale : void 0 : void 0 : void 0 : void 0;
        } else if ($('html').attr('lang')) {
          locale = $('html').attr('lang');
        }
        this.setLocale(locale);
        return this.requireLocale().then(function() {
          return dust.render(template, _this.attr.data, function(err, output) {
            var translatedOutput, _ref6;
            translatedOutput = $(output).i18n();
            _this.$node.html(translatedOutput);
            ShippingSummary.attachTo(_this.attr.shippingSummarySelector);
            CountrySelect.attachTo(_this.attr.countrySelectSelector);
            AddressSearch.attachTo(_this.attr.addressSearchSelector, {
              getAddressInformation: _this.attr.API.getAddressInformation
            });
            AddressForm.attachTo(_this.attr.addressFormSelector);
            AddressList.attachTo(_this.attr.addressListSelector);
            ShippingOptions.attachTo(_this.attr.shippingOptionsSelector);
            _this.on('enable.vtex', _this.enable);
            _this.on('disable.vtex', _this.disable);
            _this.on('addressSearchStart.vtex', _this.addressSearchLoad);
            _this.on('addressSearchResult.vtex', _this.addressSearchResult);
            _this.on('addressSelected.vtex', _this.addressSelected);
            _this.on('addressUpdated.vtex', _this.addressUpdated);
            _this.on('addressKeysUpdated.vtex', _this.addressKeysUpdated);
            _this.on('addressKeysInvalidated.vtex', _this.addressKeysInvalidated);
            _this.on('cancelAddressEdit.vtex', _this.cancelAddressEdit);
            _this.on('editAddress.vtex', _this.editAddress);
            _this.on('newAddress.vtex', _this.newAddress);
            _this.on('countrySelected.vtex', _this.countrySelected);
            _this.on('addressFormSelector', 'componentValidated.vtex', _this.addressFormValidated);
            _this.on('addressFormSubmit.vtex', _this.tryDone);
            _this.on(window, 'profileUpdated', _this.profileUpdated);
            _this.on(window, 'deliverySelected.vtex', _this.deliverySelected);
            _this.on('click', {
              'goToPaymentButtonSelector': _this.tryDone,
              'editShippingDataSelector': _this.enable
            });
            _this.setValidators([_this.validateAddress, _this.validateShippingOptions]);
            _this.on(window, 'orderFormUpdated.vtex', _this.orderFormUpdated);
            if ((typeof vtexjs !== "undefined" && vtexjs !== null ? (_ref6 = vtexjs.checkout) != null ? _ref6.orderForm : void 0 : void 0) != null) {
              _this.orderFormUpdated(null, vtexjs.checkout.orderForm);
            }
            window.vtex.maps = window.vtex.maps || {};
            return window.vtex.maps.googleMapsAPILoaded = function() {
              window.vtex.maps.isGoogleMapsAPILoaded = true;
              window.vtex.maps.isGoogleMapsAPILoading = false;
              _this.select('addressFormSelector').trigger('googleMapsAPILoaded.vtex');
              return _this.select('addressSearchSelector').trigger('googleMapsAPILoaded.vtex');
            };
          });
        });
      });
    };
    return defineComponent(ShippingData, withi18n, withValidation, withShippingStateMachine, withImplementedCountries);
  });

}).call(this);

